(($) => {
	
	app.tab = {
		event: (() => {
			return new EventEmitter();
		})(),
		activate:function(e, $tab) {
			e.preventDefault();

			app.tab.event.next('tab/' + $tab, 'activate');

			let tab_container = $(e.currentTarget).closest('[tab-container]');
			let active_state = 'bg-gray-100 text-gray-700';
			let inactive_state = 'text-gray-500 hover:text-gray-700';

			tab_container.find('[tab-handle]').removeClass('active ' + active_state).addClass(inactive_state);
			tab_container.find('[tab]').removeClass('active');

			tab_container.find('[tab-handle="'+$tab+'"]').removeClass(inactive_state).addClass('active ' + active_state);
			tab_container.find('[tab="'+$tab+'"]').addClass('active');			
		}
	};

})(jQuery);